export function getCounts(
  obs,
  files,
  issues,
  comments,
  id_field,
  Checklists = [],
) {
  obs.forEach((ob) => {
    const fl = files.filter((f) => f[id_field] === ob.id);
    ob["fileCount"] = fl.length;
    if (id_field !== "issue_id") {
      const iss = issues.filter((f) => f[id_field] === ob.id);
      ob["issueCount"] = iss.length;
    }
    if (id_field === "equipment_id") {
      const iss = Checklists.filter((f) => f.equipment_id === ob.id);
      ob["checklistCount"] = iss.length;
    }
    const com = comments.filter((f) => f[id_field] === ob.id);
    ob["commentCount"] = com.length;
    ob["Selected"] = false;
  });

  return obs;
}
